import { formatDateTime, formatDuration, isUnknownTrace, statusPillClass } from "../utils";

const AuditPerformRow = ({ perform, appName, subjectColumns = [], onOpen }) => {
  const unlinked = isUnknownTrace(perform?.trace_id);

  return (
    <tr
      className={unlinked ? "audit_row_unlinked" : "audit_row_clickable"}
      onClick={unlinked ? undefined : () => onOpen(perform.trace_id)}
      title={
        unlinked
          ? "Events that could not be linked to a specific perform (source rows had no trace id). Cannot be opened as a timeline."
          : "Open timeline"
      }
    >
      <td>{formatDateTime(perform?.started_at)}</td>
      <td>{appName || perform?.app_id || "—"}</td>
      <td>{perform?.wf_name || perform?.wf_id || "—"}</td>
      <td>{perform?.activity_name || perform?.activity_id || "—"}</td>
      {subjectColumns.map((c) => (
        <td key={c.idx} title={perform?.[`subject_${c.idx}`] || ""}>
          {perform?.[`subject_${c.idx}`] || "—"}
        </td>
      ))}
      <td>{perform?.user_email || "—"}</td>
      <td>
        <span className={`status_pill ${statusPillClass(perform?.status)}`}>{perform?.status || "—"}</span>
        {unlinked && <span className="status_pill default ml_1">unlinked</span>}
      </td>
      <td>{formatDuration(perform?.duration_ms)}</td>
      <td>{perform?.event_count ?? "—"}</td>
      <td
        style={{ maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        title={perform?.error || ""}
      >
        {perform?.error || "—"}
      </td>
    </tr>
  );
};

export default AuditPerformRow;
